__turbopack_context__.v({
  "active": "CarHero-module-scss-module__syf0Wa__active",
  "controlButtonDesktop": "CarHero-module-scss-module__syf0Wa__controlButtonDesktop",
  "controlButtonMobile": "CarHero-module-scss-module__syf0Wa__controlButtonMobile",
  "controls": "CarHero-module-scss-module__syf0Wa__controls",
  "controlsButton": "CarHero-module-scss-module__syf0Wa__controlsButton",
  "controlsButtonDoors": "CarHero-module-scss-module__syf0Wa__controlsButtonDoors",
  "controlsButtonExpand": "CarHero-module-scss-module__syf0Wa__controlsButtonExpand",
  "controlsButtonInterior": "CarHero-module-scss-module__syf0Wa__controlsButtonInterior",
  "controlsButtonWatchlist": "CarHero-module-scss-module__syf0Wa__controlsButtonWatchlist",
  "heroImage": "CarHero-module-scss-module__syf0Wa__heroImage",
  "interiorWrapper": "CarHero-module-scss-module__syf0Wa__interiorWrapper",
  "playerWrapper": "CarHero-module-scss-module__syf0Wa__playerWrapper",
  "promoPill": "CarHero-module-scss-module__syf0Wa__promoPill",
  "root": "CarHero-module-scss-module__syf0Wa__root",
  "statusWrapper": "CarHero-module-scss-module__syf0Wa__statusWrapper",
});
